const K = "mango.branding";

export const loadBranding = () => { try { return JSON.parse(localStorage.getItem(K) || "{}"); } catch { return {}; } };
export const saveBranding = (b) => { try { localStorage.setItem(K, JSON.stringify(b)); } catch { /* storage full */ } };

export const blobToDataUrl = (blob) => new Promise((resolve, reject) => {
  const r = new FileReader();
  r.onload = () => resolve(r.result);
  r.onerror = reject;
  r.readAsDataURL(blob);
});

// Logos only ever show at ~56px, so keep a 256px PNG: small enough to remember locally.
export async function shrinkLogo(file, max = 256) {
  const bmp = await createImageBitmap(file);
  const scale = Math.min(1, max / Math.max(bmp.width, bmp.height));
  const c = document.createElement("canvas");
  c.width = Math.round(bmp.width * scale);
  c.height = Math.round(bmp.height * scale);
  c.getContext("2d").drawImage(bmp, 0, 0, c.width, c.height);
  return new Promise((resolve) => c.toBlob((b) => resolve(new File([b], "logo.png", { type: "image/png" })), "image/png"));
}
